<!-- Details Dialog Backdrop -->
<div class="details-dialog-backdrop" (click)="closeDetails()"></div>


<!-- Target Details Dialog -->
<dialog *ngIf="target" class="details-dialog-target" open>
  <app-target-info [target]="target!" [isPreview]="isPreview ?? false"></app-target-info>
</dialog>

<!-- Program Details Dialog-->
<dialog *ngIf="program" class="details-dialog" open>
    <h5 class="w-100 text-center">{{program.ProgramName}}</h5>

    <div class="fw-bold">Program Instructions</div>
    <div *ngIf="isLoadingContent && program.Details == null" class="d-flex align-items-center gap-2 text-muted mt-2" role="status">
        <div class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></div>
        <span>Loading program instructions...</span>
    </div>
    <div *ngIf="!lightLoad.isEnabled() && (!isLoadingContent || program.Details != null)" class="ck ck-content bg-white  text-black p-5" [innerHTML]="this.sanitizer.bypassSecurityTrustHtml(program.Details ?? '')"></div>
    <div *ngIf="lightLoad.isEnabled()" class="text-muted mt-2">Program instructions are skipped in Light Load.</div>
    
    <div class="d-flex justify-content-between align-items-center mb-3 mt-3" *ngIf="program.BSP_SkillAcquisitionGoalID || program.SkillAcquisitionGoal_Other">
        <div>
            <div class="fw-bold">BSP Current Objective</div>
            <div class="d-block wrap-text">{{program.BSP_SkillAcquisitionGoalName ?? (program.SkillAcquisitionGoal_Other??'')}}</div>
        </div>
       
    </div>
    @if (program.BSP_SkillAcquisitionGoalID) {
      <label class="fw-bold">Treatment Goals that support this objective:</label>
      @for (goal of program.TreatmentGoals; track goal) {
        <div class="ms-3 d-flex align-items-center gap-2">
          <div>
            <div class="d-block mb-2 wrap-text text-white text-14">- {{goal}}</div>
          </div>
        </div>
        }
    }
    

    
</dialog>

<!-- Behavior BIP Info Dialog -->
<dialog *ngIf="behavior && !lightLoad.isEnabled()" class="details-dialog-behavior" open>
  <app-behavior-bip-info [patientID]="behavior!.PatientID!.toString()" 
  [selectedBehavior]="behavior!" 
  [behaviorID]="behavior!.ID!" 
  [startCurrentView]="true"
  [showDraftToggle]="false"
  ></app-behavior-bip-info>
</dialog>